import { render, staticRenderFns } from "./BlockMediasGallery.vue?vue&type=template&id=7e3fe0fa"
import script from "./BlockMediasGallery.vue?vue&type=script&lang=js"
export * from "./BlockMediasGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports